
import Chevron from '@/components/svg-components/Chevron.vue';
import Vue, { computed } from 'vue';
import BCXIcon from '@/components/molecules/BCXIcon.vue';
import { CHAT_TYPE_DIRECT } from '@/models/Messenger';
import useResponsiveness from '@/mixins/useResponsiveness';
import X from '@/components/svg-components/X.vue';
import useMessengerState from '@/state/messenger/messengerState';

export default Vue.extend({
  name: 'BCXMessengerHeader',
  components: { X, BCXIcon, Chevron },
  setup() {
    const {
      isOpened,
      isExpanded,
      selectedChat,
      isNewChat,
      unreadMessages,
      selectChat,
      showNewChatPanel,
      showOptionsPanel,
      isGroupPanelOpen,
      closeChatgroupPanel,
    } = useMessengerState();
    const { isDesktopWidth, isTooFlatForMessenger } = useResponsiveness();

    const toggleOpenedOrClose = () => {
      if (isDesktopWidth.value) {
        isOpened.value = !isOpened.value;
      } else {
        isOpened.value = false;
      }
    };

    const goBack = () => {
      if (isGroupPanelOpen.value) {
        closeChatgroupPanel();
        return;
      }
      selectChat('');
    };

    const goBackLabel = computed(() => (selectedChat.value?.type ?? CHAT_TYPE_DIRECT));

    const showBackButton = computed(() => isGroupPanelOpen.value
      || ((!!selectedChat.value || isNewChat.value) && !isExpanded.value));

    const backLabelKey = computed(() => {
      if (isGroupPanelOpen.value) return 'messenger.chatgroup.details';
      if (isNewChat.value) return 'messenger.header.new_chat';
      return `messenger.types.${goBackLabel.value}.header`;
    });

    const openNewChatPanel = () => {
      isOpened.value = true;
      showOptionsPanel.value = false;
      showNewChatPanel.value = true;
    };

    const openOptionsPanel = () => {
      showNewChatPanel.value = false;
      showOptionsPanel.value = true;
    };

    const clickExpanded = () => {
      const newExpanded = !isExpanded.value;
      isExpanded.value = newExpanded;
      if (!newExpanded && isTooFlatForMessenger.value) {
        isOpened.value = false;
      }
      if (newExpanded && !isOpened.value) {
        requestAnimationFrame(() => { isOpened.value = true; });
      }
    };

    return {
      goBack,
      showBackButton,
      backLabelKey,
      isOpened,
      isExpanded,
      isDesktopWidth,
      isNewChat,
      selectedChat,
      unreadMessages,
      toggleOpenedOrClose,
      openNewChatPanel,
      openOptionsPanel,
      clickExpanded,
      showNewChatPanel,
      showOptionsPanel,
    };
  },
});
